module.exports = __webpack_public_path__ + "static/media/02-1-galeria-02-santa-fe@2x.cb4e9592.jpg";